import React, { CSSProperties, memo } from 'react'
import cls from './stage.module.css'
import { classNames } from '../../../../../../../lib/classNames/classNames'

interface StageProps {
  className?: string
  children?: string
  style?: CSSProperties
}

const Stage: React.FC<StageProps> = memo((props: StageProps) => {
  const { className, children, style } = props

  return (
    <span
      className={classNames(cls.Stage, {}, [className])}
      style={{
        ...style,
        color: !style?.color ? '#000' : style.color,
      }}
    >
      {children}
    </span>
  )
})

Stage.displayName = 'Stage'
export default Stage
